module.exports = __webpack_public_path__ + "img/sozialschnellgut_10_a.2cb53de4.jpg";